module.exports = __webpack_public_path__ + "ace8ffda34b7a2825b0014be241a5b40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/dog-ears.png
// module id = 2177
// module chunks = 0